import React from 'react';
import WelligenceLogoTransparentWhite from '../../../assets/images/welligence-transparent-white.png';

export const WelligenceLogo = () => {
  return (
    <img
      src={WelligenceLogoTransparentWhite}
      alt="Welligence Logo"
      style={{ width: '80%', maxHeight: '80%' }}
    />
  );
};
